module.exports = __webpack_public_path__ + "img/4.48ab4d51.jpg";